import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <div className="hero-section text-center">
      <div className="container">
        <h1 className="hero-title">Unlock Your Chess Potential</h1>
        <p className="hero-subtitle">
          Welcome to Polonsky Academy, where passion for chess meets expert guidance. 
          Our world-class coaching is designed to elevate your game, whether you're a beginner or a seasoned competitor.
        </p>
        <Link to="/book/free-trial" className="btn btn-lg btn-success">Book a Free Trial Lesson</Link>
      </div>
    </div>
  );
};

export default Hero;
